import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import theme from '../../../styles/theme';
import useInView from '../../../hooks/useInView';

const CTASection = ({ onLoginClick }) => {
  const { t } = useTranslation();
  const [ref, visible] = useInView();

  const s = {
    section: {
      padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
      background: `linear-gradient(135deg, ${theme.colors.primary.dark} 0%, ${theme.colors.primary.main} 100%)`,
    },
    inner: {
      maxWidth: '660px',
      margin: '0 auto',
      textAlign: 'center',
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(20px)',
      transition: 'opacity 0.6s ease, transform 0.6s ease',
    },
    h2: {
      fontSize: theme.typography.fluid.h2,
      fontWeight: theme.typography.fontWeight.bold,
      fontFamily: theme.typography.fontFamily.heading,
      color: '#fff',
      marginBottom: theme.spacing.lg,
    },
    sub: {
      fontSize: theme.typography.fontSize.lg,
      color: 'rgba(255,255,255,0.8)',
      lineHeight: theme.typography.lineHeight.relaxed,
      marginBottom: theme.spacing['2xl'],
    },
    actions: {
      display: 'flex',
      gap: theme.spacing.md,
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    primaryBtn: {
      backgroundColor: theme.colors.accent.main,
      color: theme.colors.accent.onMain,
      border: 'none',
      borderRadius: theme.borderRadius.full,
      padding: `${theme.spacing.md} ${theme.spacing['2xl']}`,
      fontSize: theme.typography.fontSize.base,
      fontWeight: theme.typography.fontWeight.semibold,
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block',
      transition: `background-color ${theme.transitions.fast}`,
    },
    secondaryBtn: {
      backgroundColor: 'rgba(255,255,255,0.12)',
      color: '#fff',
      border: '1px solid rgba(255,255,255,0.4)',
      borderRadius: theme.borderRadius.full,
      padding: `${theme.spacing.md} ${theme.spacing['2xl']}`,
      fontSize: theme.typography.fontSize.base,
      fontWeight: theme.typography.fontWeight.medium,
      cursor: 'pointer',
      transition: `background-color ${theme.transitions.fast}`,
    },
  };

  return (
    <section style={s.section}>
      <div style={s.inner} ref={ref}>
        <h2 style={s.h2}>{t('public.cta.heading', 'Ready to simplify your pet store?')}</h2>
        <p style={s.sub}>{t('public.cta.sub', 'Join stores already running on Waggy. Get started in minutes.')}</p>
        <div style={s.actions}>
          <Link
            to="/register/start?plan=growth"
            style={s.primaryBtn}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = theme.colors.accent.hoverAccessible)}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = theme.colors.accent.main)}
          >
            {t('public.cta.primary', 'Request a demo')}
          </Link>
          <button
            style={s.secondaryBtn}
            onClick={onLoginClick}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.22)')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)')}
          >
            {t('public.cta.secondary', 'Log in')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
